export default "__VITE_ASSET__DcEM9DR$__"